//医院管理员
export const adminRouter=[
    {//医院管理
        path:'/hospAdmin',
        name:'hospAdmin',
        component: () => import(/* webpackChunkName: 'hospAdmin' */ '@/page/hospAdmin')
    },
    {//科室管理
        path:'/deptManage',
        name:'deptManage',
        component: () => import(/* webpackChunkName: 'deptManage' */ '@/page/deptManage')
    },
]
//科室管理员
export const deptRouter=[
    {//科室管理首页
        path:'/deptAdmin',
        name:'deptAdmin',
        component: () => import(/* webpackChunkName: 'deptAdmin' */ '@/page/deptAdmin')
    },
    {//医生管理
        path:'/doctorManage',
        name:'doctorManage',
        component: () => import(/* webpackChunkName: 'doctorManage' */ '@/page/doctorManage')
    },
    {//会诊时间设置
        path:'/consulTime',
        name:'consulTime',
        component: () => import(/* webpackChunkName: 'consulTime' */ '@/page/consulTime')
    }
]
//通用
export const commonRouter=[
    {//会诊医院（无权限）
        path:'/listHosp',
        name:'listHosp',
        component: () => import(/* webpackChunkName: 'listHosp' */ '@/page/listHosp')
    },
    {//医院信息
        path:'/hospInfo',
        name:'hospInfo',
        component: () => import(/* webpackChunkName: 'hospInfo' */ '@/page/hospInfo')
    },
    {//个人中心
        path:'/userInfo',
        name:'userInfo',
        component: () => import(/* webpackChunkName: 'userInfo' */ '@/page/userInfo')
    },
]
//普通医生
export const docRouter=[
    {//问诊首页
        path: '/phyVisit',
        name: 'phyVisit',
        component:  () => import(/* webpackChunkName: 'phyVisit' */ '@/page/phyVisit')
    },
    {//问诊室
        path:'/phyOffice',
        name:'phyOffice',
        component: () => import(/* webpackChunkName: 'phyOffice' */ '@/page/phyOffice')
    },
    {//选择医院
        path:'/selectHosp',
        name:'selectHosp',
        component: () => import(/* webpackChunkName: 'appoint' */ '@/page/selectHosp')
    },
    {//医院信息
        path:'/hospMsg',
        name:'hospMsg',
        component: () => import(/* webpackChunkName: 'hospMsg' */ '@/page/hospMsg')
    },
    {//选择科室
        path:'/selectDepart',
        name:'selectDepart',
        component: () => import(/* webpackChunkName: 'appoint' */ '@/page/selectDepart')
    },
    {//申请单
        path:'/appointForm',
        name:'appointForm',
        component: () => import(/* webpackChunkName: 'appoint' */ '@/page/appointForm')
    },
    {//预约成功
        path:'/subComp',
        name:'subComp',
        component: () => import(/* webpackChunkName: 'subComp' */ '@/page/subComp')
    },
    {//会诊首页
        path:'/consultation',
        name:'consultation',
        component: () => import(/* webpackChunkName: 'consultation' */ '@/page/consultation')
    },
    {//会诊室
        path:'/consultOffice',
        name:'consultOffice',
        component: () => import(/* webpackChunkName: 'consultOffice' */ '@/page/consultOffice')
    },
    {//会诊申请单详情(问诊，会诊)
        path:'/formDetails',
        name:'formDetails',
        component: () => import(/* webpackChunkName: 'formDetails' */ '@/page/formDetails')
    },
    {//远程会诊咨询意见书(问诊，会诊)
        path:'/reportInfo',
        name:'reportInfo',
        component: () => import(/* webpackChunkName: 'reportInfo' */ '@/page/reportInfo')
    },
]



// WEBPACK FOOTER //
// ./src/router/staticRoute.js